<template>
    <div class="msg-rcv" :id="'message-' + message.messageID">
        <div class="row mli" v-on:click="toggleMessageView">
            <div class="select-all"><input type="checkbox" @click.stop="checkedChanged" :checked="isChecked"></div>
            <div class="status"><img src="/icons/icon_mail.png" /></div>
            <div class="subject">{{ message.subject | decodeHtml }}</div>
            <div class="from">{{ message.fromMemberDisplayName }}</div>
            <div class="recd-date">{{ message.receivedDateUTC | localDateTime }}</div>
            <div style="float:right; width: 56px; margin-left: 5px; height: 42px; margin-top:-8px;">
              <button @click.stop="reply" v-if="!showComposer">Reply</button>
              <button @click.stop="deleteMessage" v-if="!showComposer">Delete</button>
            </div>
        </div>
        <MessageViewer v-if="showViewer" :message="this.message"></MessageViewer>
        <MessageComposer v-if="showComposer" ref="composer" v-bind="{
            recipients: [parseInt(this.message.fromMemberID)],
            cancelled: this.cancelled,
            submitted: this.submitted,
            showSubject: false,
            subject: this.replySubject
        }" />
    </div>
</template>

<script>
    export default {

        props: ['message', 'isChecked', 'showMessage'],


        data() {
            return {
                showViewer: false,
                showComposer: false
            }
        },

        components: {
            MessageViewer: () => import('../../components/Messages/MessageViewer.vue'),
            MessageComposer: () => import('../../components/Messages/MessageComposer.vue')
        },

        computed: {
            replySubject() {
                return this.message.subject.includes("Re: ") ? this.message.subject : "Re: " +  this.message.subject;
            }
        },

        methods: {
            cancelled() {
                this.showComposer = false;
            },
            submitted() {
                this.showComposer = false;
                window.location.reload();
            },
            toggleMessageView: function() {
                this.showViewer = !this.showViewer;
            },
            reply() {
              this.showComposer = true;
            },
            deleteMessage() {
                this.$emit("deleteMessage", {
                    receiptId: this.message.receiptID
                });
            },
            checkedChanged() {
                const newValue = !this.isChecked;
                this.$emit("checkChanged", {
                    value: newValue,
                    receiptID: this.message.receiptID
                })
            },

        },

        mounted () {
            if(this.message.messageID == this.showMessage) {
                this.showViewer = true;
                let elem = document.getElementById('message-' + this.showMessage);
                if(elem) {
                    var headerOffset = 45;
                    var elementPosition = elem.getBoundingClientRect().top;
                    var offsetPosition = elementPosition - headerOffset;

                    window.scrollTo({
                         top: offsetPosition,
                         behavior: "smooth"
                    });
                }
            }
        }
    }

</script>
